// MODULES
import React from "react";
import PropTypes from "prop-types";

// CLASSES
import Partner from "@classes/Partner";
import Session from "@classes/Session";

// COMPONENTS
import DefaultFields from "@routes/Cob/components/DefaultFields/DefaultFields";
import HiddenDefaultFields from "@routes/Cob/components/HiddenDefaultFields/HiddenDefaultFields";

// HELPERS
import {createClassName} from "@helpers/utils";
import * as CobHelpers from "@routes/Cob/Cob.helpers";

// OTHER
import partnerFields from "./partners";


export default class CobQuestionnaire extends React.PureComponent {
	static propTypes = {
		id: PropTypes.string.isRequired,
		title: PropTypes.string.isRequired,
		partner: PropTypes.instanceOf(Partner).isRequired,
		session: PropTypes.instanceOf(Session).isRequired,
		sectionNumber: PropTypes.number.isRequired,
		number: PropTypes.number.isRequired,
		prevState: PropTypes.object,
		onChange: PropTypes.func.isRequired,
	};

	static companyExclusive = false;
	static privateExclusive = false;

	state = _getInitialState.call(this);

	componentDidUpdate(prevProps, prevState) {
		const {props, state} = this;
		const {id, partner, onChange} = props;
		const fulfillmentCheck = partnerFields[partner.name].fulfillmentCheck;

		if (prevState.fields !== state.fields) {
			onChange(id, {...state}, fulfillmentCheck(props, state));
		}
	}

	render() {
		const {props, state} = this;
		const {title, partner, session, app, availableBanks} = props;
		const classes = createClassName("Cob-Questionnaire", {
			"Cob-View": true,
			"fulfilled": state.isFulfilled,
		});
		const Fields = partnerFields[partner.name].Component;

		return (
			<div className={classes}>
				<DefaultFields fields={Fields.getFieldNames()}/>
				<HiddenDefaultFields fields={Fields.getHiddenDefaultFields.call(this)}/>

				<Fields
					title={title}
					partner={partner}
					session={session}
					fields={state.fields}
					validFields={state.validFields}
					availableBanks={availableBanks}
					app={app}
					numberLocaleFormatter={this._numberLocaleFormatter}
					onFieldChange={this._onFieldChange}
					onFieldBlur={this._onFieldBlur}
					onSelectChange={this._onSelectChange}
					onOptionsListChange={this._onOptionsListChange}
					onCheckboxChange={this._onCheckboxChange}
				/>
			</div>
		);
	}

	// Internal methods
	_fieldValidator = partnerFields[this.props.partner.name].Component.fieldValidator;

	_numberLocaleFormatter = (value) => {
		let parsedValue = value.replace(/[\D\s._-]+/g, "");
		parsedValue = parsedValue || parsedValue === "0" ? parseInt(parsedValue, 10) : null;
		return parsedValue === null ? "" : parsedValue;
	};

	_onFieldChange = (name, value, manualValidation) => {
		if (manualValidation === undefined) {
			manualValidation = null;
		}

		CobHelpers.onViewFieldChange.call(this, name, value, manualValidation);
	};

	_onFieldBlur = (name, skipValidation) => {
		if (skipValidation === undefined) {
			skipValidation = false;
		}

		CobHelpers.onViewFieldBlur.call(this, name, null, skipValidation);
	};

	_onSelectChange = (fieldKey, option, index) => {
		const {partner} = this.props;
		const fulfillmentCheck = partnerFields[partner.name].fulfillmentCheck;

		this.setState({
			fields: {
				...this.state.fields,
				[fieldKey]: {
					...this.state.fields[fieldKey],
					index: index,
				},
			},
		}, () => fulfillmentCheck(this.props, this.state));
	};

	_onOptionsListChange = ({type, name}, option, index) => {
		name = name || option.name;
		const {partner} = this.props;
		const fulfillmentCheck = partnerFields[partner.name].fulfillmentCheck;
		const newOptions = [...this.state.fields[name].options].map((o, i) => {
			if (i === index) {
				return option;
			}
			else {
				return {...o, checked: type === "radio" ? false : o.checked};
			}
		});

		this.setState({
			fields: {
				...this.state.fields,
				[name]: {
					options: newOptions,
				},
			},
		}, () => fulfillmentCheck(this.props, this.state));
	};

	_onCheckboxChange = (name, checked) => {
		this.setState({
			fields: {
				...this.state.fields,
				[name]: {...this.state.fields[name], checked},
			},
		});
	}
}


// PRIVATE FUNCTIONS
function _getInitialState() {
	const {props} = this;
	const {session} = props;
	if (props.prevState) return {...props.prevState};

	const {partner} = props;
	let filledPartnerFields = partnerFields[partner.name].Component.setupFieldsState(this);

	/**
	 * Set some variables manually. For example account type selection should be visible for Nord FK only
	 * if you come from the advisory application (and have a session.context value set). Otherwise this
	 * section should be hidden.
	 */
	if ('has_account_type_selection' in filledPartnerFields) {
		filledPartnerFields.has_account_type_selection = session.context != null;
	}

	return {
		fields: filledPartnerFields,
		validFields: {},
	};
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Questionnaire/Questionnaire.js